<template>
  <div class="bbe-email-card"
       @click="setThread"
       @mouseenter="setHoverThread"
       @mouseleave="delHoverThread"
       :class="{
         'bbe-email-card_first-child': index === 0,
         'bbe-email-card_before-active': activeThreadIndex === index - 1,
         'bbe-email-card_active': activeThread ? activeThread.id === thread.id : false,
         'bbe-email-card_after-active': activeThreadIndex === index + 1
       }">
    <transition name="bbe-list-complete">
      <div class="bbe-email-card-thread"
           :class="{
             'bbe-email-card-thread_active': activeThread ? activeThread.id === thread.id : false,
           }">
        <div class="bbe-email-card-thread-checkbox">
          <transition name="bbe-bounce">
            <checkbox :name="thread"
                      v-if="threadHover || checkedMails.includes(thread.id)"
                      @checkboxChange="mailChecked"
                      :value="checkedMails.includes(thread.id)"/>
          </transition>
        </div>
       <div>
         <img
           class="bbe-email-card-thread__image"
           alt="photo"
           :src="thread.userImage || defaultAvatar"
         />
         <div class="bbe-email-card-thread__tracker">
           <MailTrackerIndicator :thread="thread" v-if="activeTab === 'SENT'"/>
         </div>
       </div>
        <div class="bbe-email-card-thread-content">
          <div class="bbe-email-card-thread-content-header">
            <div class="bbe-email-card-thread-content-header__mail"
                 :class="{'bbe-email-card-thread-content-header__mail_unread': thread.unread}">
              {{ thread.from.name }}
              <div class="bbe-email-card-thread-content-header__indicator"
                   :class="{'bbe-email-card-thread-content-header__indicator_active': thread.unread}"/>
            </div>
            <div class="bbe-email-card-thread-content-header-options">
              <transition name="bbe-fade-options" mode="out-in">
<!--                v-if="threadHover"-->
                <EmailListOptions
                  v-if="threadHover"
                  :thread="thread"
                  :option-action="optionAction"
                  :custom-type="customType"
                  :checked-mails="checkedMails"
                />
                <div v-else>
                  {{ thread.dateFormat }}
                </div>
              </transition>
            </div>
          </div>
          <div class="bbe-email-card-thread-content__subject">{{ thread.subject }}</div>
          <VuePerfectScrollbar class="bbe-email-card-thread-content-tags"
                               v-if="thread.tags && thread.tags.length > 0"
                               v-dragscroll>
            <div class="bbe-email-card-thread-content-tags__tag"
                 v-for="tag in thread.tags"
                 :key="tag.id">
              #{{ tag.name }}
            </div>
          </VuePerfectScrollbar>
          <div class="bbe-email-card-thread-content__snippet" v-html="thread.snippet"/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import defaultAvatar from '@/assets/images/user.png'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {dragscroll} from 'vue-dragscroll'
import MailTrackerIndicator from '@/components/Main/MailTracker/MailTrackerIndicator'
import checkbox from '@/components/Main/FormsElements/checkbox'
import EmailListOptions from '@/components/Email/EmailList/EmailListOptions/EmailListOptions'

export default {
  name: 'EmailListCard',
  props: [
    'index',
    'checkedMails',
    'customType',
    'optionAction',
    'activeThreadIndex',
    'activeThread',
    'source'
  ],
  components: {
    EmailListOptions,
    VuePerfectScrollbar,
    MailTrackerIndicator,
    checkbox
  },
  directives: {
    dragscroll
  },
  computed: {
    thread () {
      return this.source
    },
    activeEmail () {
      return this.$store.getters.activeEmail
    },
    activeTab () {
      return this.$store.getters.activeTab
    }
  },
  data () {
    return {
      threadHover: false,
      defaultAvatar: defaultAvatar
    }
  },
  methods: {
    setThread () {
      this.optionAction.setThread({
        thread: this.thread,
        index: this.index
      })
    },
    mailChecked (data, name) {
      this.$emit('mailChecked', data, name)
    },
    delHoverThread () {
      this.threadHover = false
    },
    setHoverThread () {
      this.threadHover = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbe-email-card {
  width: 100%;
  min-height: 158px;
  height: 158px;
  display: flex;
  position: relative;
  transition: .3s;
  cursor: pointer;
  background-color: $color-white;

  &:after {
    @include line-after-top;
  }

  &_first-child {
    &:after {
      background-color: transparent;
    }
  }

  &_before-active {
    border-radius: 0 15px 0 0;
    transition: .3s;
  }

  &_active {
    background-color: $color-wild-sand;
    cursor: default;
  }

  &_after-active {
    border-radius: 0 0 15px 0;
    transition: .3s;
  }

  &-thread {
    width: 100%;
    display: grid;
    grid-template-columns: 15px 39px auto;
    grid-gap: 15px;
    position: relative;
    padding: 20px 22px 20px 18px;
    transition: 0.3s;

    &:hover:not(&_active) {
      background-color: $color-white;
      box-shadow: 0 0 25px rgba($color-accent, 0.12);
      border-radius: 15px;
      z-index: 1;
    }

    &-checkbox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 39px;
    }

    &__image {
      width: 39px;
      height: 39px;
      object-fit: contain;
      border-radius: 50%;
    }

    &__tracker {
      margin-top: 16px;
    }

    &-content {

      &-header {
        display: flex;
        margin-bottom: 5px;

        &__mail {
          display: inline-flex;
          align-items: center;
          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 310px;

          &_unread {
            font-weight: 600;
          }
        }

        &__indicator {
          margin-left: 6px;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: $color-accent;
          opacity: 0;

          &_active {
            opacity: 1;
          }
        }

        &-options {
          align-self: flex-start;
          margin-left: auto;
          margin-right: 0;
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          color: $color-silver-chalice;
        }
      }

      &__subject {
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 414px;
        margin-right: 8px;
        margin-bottom: 8px;
      }

      &-tags {
        position: relative;
        display: flex;
        align-items: center;
        max-width: 414px;
        margin-bottom: 8px;
        overflow: hidden;

        &__tag {
          margin-right: 8px;
          padding: 4px;
          background-color: $color-link-water;
          border-radius: 4px;
          color: $color-accent;
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;
          white-space: nowrap;
        }
      }

      &__snippet {
        grid-column: 1/3;
        grid-row: 4;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: $color-silver-chalice;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 414px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Email/EmailList/EmailListCard/EmailListCard.vue